import { SuggestionItem } from "@/types/suggestions";

/** primary DEFAULT from tailwind.config.ts — used as fallback for user-defined tag colors. */
export const DEFAULT_TAG_COLOR = "#0178D4";

export const MESSAGE_SUGGESTIONS: SuggestionItem[] = [
  {
    id: "first_name",
    label: "Patient First Name",
    content: "Jane",
    type: "PATIENT",
  },
  {
    id: "last_name",
    label: "Patient Last Name",
    content: "Doe",
    type: "PATIENT",
  },
  {
    id: "provider_name",
    label: "Provider Name",
    content: "Dr. Smith",
    type: "TEAM",
  },
  {
    id: "tenant_name",
    label: "Clinic Name",
    content: "Decoda Clinic",
    type: "TENANT",
  },
  {
    id: "location_name",
    label: "Location Name",
    content: "Main Office",
    type: "TENANT",
  },
  {
    id: "plan_name",
    label: "Care Plan Name",
    content: "Weight Loss Program",
    type: "TENANT",
  },
  { id: "step_number", label: "Step Number", content: "3", type: "EVENT" },
  {
    id: "next_step_date",
    label: "Next Step Date",
    content: "March 15, 2026",
    type: "EVENT",
  },
  {
    id: "start",
    label: "Appointment Time",
    content: "10:00 AM",
    type: "EVENT",
  },
  {
    id: "location",
    label: "Appointment Location",
    content: "123 Main St",
    type: "EVENT",
  },
];
